import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import SideBar from "../Components/SideBar";
import styles from "./Universities.module.scss";
import { getUniversityStats } from "../Components/enquiryProfileApi";

export default function UniversitiesReportsPage() {
  const [stats, setStats] = useState({
    total_universities: 0,
    pending_approvals: 0,
    most_used_universities: [],
    chart_ready: [],
  });

  const load = useCallback(async () => {
    try {
      const data = await getUniversityStats();
      setStats((prev) => ({
        ...prev,
        ...data,
      }));
    } catch (error) {
      toast.error(error.message || "Failed to load university reports.");
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Container fluid className={`${styles.page} p-0`}>
      <Row className="g-0">
        <Col md={2} className="sidebar-column">
          <div className="sidebar-wrapper">
            <SideBar />
          </div>
        </Col>
        <Col md={10} className={styles.main}>
          <div className={styles.statsGrid}>
            <article className={styles.statCard}>
              <p className={styles.statLabel}>Total universities</p>
              <p className={styles.statValue}>{stats.total_universities || 0}</p>
            </article>
            <article className={styles.statCard}>
              <p className={styles.statLabel}>Pending approvals</p>
              <p className={styles.statValue}>{stats.pending_approvals || 0}</p>
            </article>
            <article className={styles.statCard}>
              <p className={styles.statLabel}>Most used university count</p>
              <p className={styles.statValue}>{stats.most_used_universities?.length || 0}</p>
            </article>
          </div>

          <section className={styles.panel}>
            <h5>Most Used Universities</h5>
            <div className={styles.tableWrap}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>University</th>
                    <th>Usage</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.most_used_universities?.length ? (
                    stats.most_used_universities.map((item) => (
                      <tr key={item.name}>
                        <td>{item.name}</td>
                        <td>{item.usage_count}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2}>No usage data yet.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>

          <section className={`${styles.panel} mt-3`}>
            <h5>Chart-Ready Data</h5>
            <div className={styles.chartReady}>
              <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                {JSON.stringify(stats.chart_ready || [], null, 2)}
              </pre>
            </div>
          </section>
        </Col>
      </Row>
    </Container>
  );
}
